export default __webpack_public_path__ + "media/052165705ae73e38afd6ceee3c8d7231caae5f2bdf4d5b17fd55a281ac740408.svg";